import { render } from "./VabeneUsersList.vue?vue&type=template&id=1ee55988&scoped=true&ts=true"
import script from "./VabeneUsersList.vue?vue&type=script&lang=ts"
export * from "./VabeneUsersList.vue?vue&type=script&lang=ts"

import "./VabeneUsersList.vue?vue&type=style&index=0&id=1ee55988&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ee55988"]])

export default __exports__